import Vue from 'vue'

const mutations = {
	setClientsStatisticsData (state, data) {
		Vue.set(state, 'clientsStatisticsData', data)
	}
}

export default mutations
